import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MedicareConfig } from '@core/interfaces/api-responses/medicare-config';
import { FeatureFlag } from '@core/interfaces/entities/feature-flag';


@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private root = `${environment.services.mpsrApi.url}/utils`;

  constructor(private httpClient: HttpClient) {
  }

  validateValueExists(type: string, value: string = '', year = null): Observable<{ exists: boolean }> {
    return this.httpClient.get<{ exists: boolean }>(`${this.root}/value-exists`, {
      params: {
        query: value,
        type,
        year
      },
    });
  }

  getMedicareEnrollmentConfig(): Observable<MedicareConfig> {
    return this.httpClient.get<MedicareConfig>(`${this.root}/medicare-config`);
  }

  getFeatureFlags(): Observable<FeatureFlag> {
    return this.httpClient.get<FeatureFlag>(`${this.root}/feature-flags`);
  }

}
